import { render, staticRenderFns } from "./ParametrosLocalesForm.vue?vue&type=template&id=53e26896&scoped=true"
import script from "./ParametrosLocalesForm.vue?vue&type=script&lang=js"
export * from "./ParametrosLocalesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e26896",
  null
  
)

export default component.exports